import { gql } from '@apollo/client';

export const CHECK_INVITE_BY_EMAIL = gql`
  query CheckInviteByEmail($email: String!, $tenantId: String!) {
    inviteCheck(email: $email, tenantId: $tenantId)
      @rest(
        type: "InviteCheck"
        path: "/invite/check?email={args.email}&tenantId={args.tenantId}"
        method: "GET"
      ) {
      success
      errorCode
      message
      invite {
        id
        email
        userRole
        tenantId
        clientId
        code
        expiresAt
      }
    }
  }
`;
